import { NotificationsPageConfig } from './notifications.config';

/**
 * Maps the raw Investigations enum name shipped on the payload to a human-friendly label for the
 * Type column. Falls back to splitting the PascalCase enum into words when an unmapped type slips
 * through, so new notification types don't show up as gibberish until this catalog catches up.
 */
const INVESTIGATIONS_TYPE_LABELS: Record<string, string> = {
  InvAgentAssignedToMe: 'Assignment',
  InvAgentReassignedAway: 'Reassignment',
  InvAgentStatusChanged: 'Status change',
  InvAgentClosedOrResolved: 'Resolved',
  InvAgentClosedCaseReopened: 'Reopened',
  InvAgentResponseTimeSLA: 'SLA warning',
  InvAgentResolutionTimeSLA: 'SLA warning',
  InvAgentOverdue: 'Overdue',
  InvAgentApprovalRequested: 'Approval requested',
  InvAgentChecklistCompleted: 'Checklist completed',
  InvAgentWatcherAddMe: 'Watcher added',
  InvAgentComNewMessage: 'New message',
  InvAgentComNewMessageFromEmployee: 'New message',
  InvAgentComNewFile: 'New file',
  InvManagerAgentOverCapacity: 'Capacity',
  InvManagerAgentOOO: 'Agent OOO',
  InvManagerNewCaseHandedOff: 'Handed off',
  InvManagerApprovalAssignedToMe: 'Approval assigned',
  InvManagerResponseTimeSLA: 'SLA breach',
  InvManagerResolutionTimeSLA: 'SLA breach',
  InvDirCaseOpened: 'Case opened',
  InvDirCaseClosed: 'Case closed',
};

export const INVESTIGATIONS_NOTIFICATIONS_CONFIG: NotificationsPageConfig = {
  routePrefix: '/investigations',
  numberField: 'investigationNumber',
  typeLabels: INVESTIGATIONS_TYPE_LABELS,
  // Equivalent to the previous two-step strip: `^Inv(Agent|Manager|Dir)Com?` then `^Inv(Agent|Manager|Dir)`.
  typePrefixPattern: /^Inv(?:Agent|Manager|Dir)(?:Com?)?/,
  autIdPrefix: 'investigations-',
  rowAutIdPrefix: 'investigation-',
};
